import { render, staticRenderFns } from "./totalDocumentByType.vue?vue&type=template&id=08657afe&"
import script from "./totalDocumentByType.vue?vue&type=script&lang=js&"
export * from "./totalDocumentByType.vue?vue&type=script&lang=js&"
import style0 from "./totalDocumentByType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports